module.exports = __webpack_public_path__ + "img/27.8f691104.jpg";